import { Tag } from "antd";

const CustomTag = ({ label, color = "blue", style, children, ...rest }) => {
  return (
    <Tag
      color={color}
      style={{
        borderRadius: "6px",
        padding: "4px 12px",
        fontWeight: 500,
        fontSize: "14px",
        ...style,
      }}
      {...rest}
    >
      {children || label}
    </Tag>
  );
};

export default CustomTag;
